import React from 'react';
import styles from './index.css';
import loading from './loading.png';

const Cover = () => (
  <div
    id={styles.root}
  >
    <img
      id={styles.rootSpinner}
      src={loading}
      alt="spinner"
      width="150"
      height="150"
    />
  </div>
);
export default Cover;



// WEBPACK FOOTER //
// ./src/components/App/Cover/index.jsx